import React from "react";
import { formatCategoryName } from "../../../../utils/chartUtil";
import { useResponsiveStyles } from "../../../../styles/useResponsiveStyles";

const getColor = (category) => {
    const categoryMap = {
        "Corp NDR": "#ED1C24",
        Conference: "#333896",
        "Expert NDR": "#03781D",
        Events: "#7A460A",
    };
    return categoryMap[category] || "#666";
};
export const CustomXAxisTick = ({ x = 0, y = 0, payload }) => {
    const { getFontSize } = useResponsiveStyles();
    if (!payload) return null;

    const category = payload.value.split("|")[1];
    const formattedCategory = category ? formatCategoryName(category) : "";

    return (
        <g transform={`translate(${x},${y})`}>
            {/* <text
                x={0}
                y={0}
                dy={16}
                textAnchor="end"
                fill="#666"
                transform="rotate(-45)"
                style={getFontSize("body1")}
            >
                
            </text> */}
            <text
                x={0}
                y={0}
                dy={28}
                textAnchor="end"
                fill={getColor(formattedCategory)}
                style={getFontSize("body1")}
                transform="rotate(-45)"
            >
                {payload.value.split("|")[0]}{formattedCategory}
            </text>
        </g>
    );
};
